export default __webpack_public_path__ + "media/images/features/local_delivery/space_logo-82a75ca68cdd0592fccd2dbcd3bf696b.jpg";